import React from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Filter} from 'presentation/components/Filter';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useExamList} from '../../../../pages/ExamBooking/steps/ExamSelection/hooks/useExamList';

export function ExamsFilterByLetter() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const {examsList, examsListError, isFetchingExamsList} = useExamList();

	const NOT_FOUND = !examsList || examsList.length === 0;
	const HIDDEN_FILTER_BY_LETTER = examsListError || isFetchingExamsList || NOT_FOUND;
	if (HIDDEN_FILTER_BY_LETTER) {
		return null;
	}

	const FILTERED_LIST_BY_CATEGORY = examsList.map(specialty => ({
		...specialty,
		list: specialty.list.filter(item =>
			item.formattedText.toLowerCase().includes(query.trim().toLowerCase()),
		),
	}));

	return (
		<Filter.Letter
			dataTagId={AppointmentBookingEnum.CLICK_FILTRAR_ESPECIALIDADE}
			filteredList={FILTERED_LIST_BY_CATEGORY}
		/>
	);
}
